import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, BuildingIcon, ShoppingCartIcon, ZapIcon, ArrowDownLeftIcon, CoffeeIcon, WifiIcon, CarIcon, UtensilsIcon } from 'lucide-react';
import { useTheme } from '../utils/theme';
interface TransactionsScreenProps {
  onBack: () => void;
}
type FilterType = 'all' | 'incoming' | 'outgoing';
const mockTransactions = [{
  id: 1,
  title: 'Salary Credit',
  date: 'Today, 09:00 AM',
  amount: '250,000.00',
  type: 'incoming',
  icon: BuildingIcon,
  iconBg: '#10B981'
}, {
  id: 2,
  title: 'Grocery Store',
  date: 'Yesterday, 06:30 PM',
  amount: '12,450.00',
  type: 'outgoing',
  icon: ShoppingCartIcon,
  iconBg: '#F59E0B'
}, {
  id: 3,
  title: 'Electric Bill',
  date: 'Oct 24, 10:15 AM',
  amount: '8,200.00',
  type: 'outgoing',
  icon: ZapIcon,
  iconBg: '#EF4444'
}, {
  id: 4,
  title: 'Ali Transfer',
  date: 'Oct 23, 02:45 PM',
  amount: '5,000.00',
  type: 'incoming',
  icon: ArrowDownLeftIcon,
  iconBg: '#10B981'
}, {
  id: 5,
  title: 'Coffee Shop',
  date: 'Oct 22, 08:20 AM',
  amount: '850.00',
  type: 'outgoing',
  icon: CoffeeIcon,
  iconBg: '#8B5CF6'
}, {
  id: 6,
  title: 'Internet Bill',
  date: 'Oct 20, 11:00 AM',
  amount: '3,500.00',
  type: 'outgoing',
  icon: WifiIcon,
  iconBg: '#3B82F6'
}, {
  id: 7,
  title: 'Freelance Work',
  date: 'Oct 18, 04:30 PM',
  amount: '45,000.00',
  type: 'incoming',
  icon: ArrowDownLeftIcon,
  iconBg: '#10B981'
}, {
  id: 8,
  title: 'Fuel Station',
  date: 'Oct 15, 07:10 PM',
  amount: '6,000.00',
  type: 'outgoing',
  icon: CarIcon,
  iconBg: '#F59E0B'
}, {
  id: 9,
  title: 'Restaurant',
  date: 'Oct 12, 09:45 PM',
  amount: '4,200.00',
  type: 'outgoing',
  icon: UtensilsIcon,
  iconBg: '#EC4899'
}];
export function TransactionsScreen({
  onBack
}: TransactionsScreenProps) {
  const {
    isDark
  } = useTheme();
  const [filter, setFilter] = useState<FilterType>('all');
  const filteredTransactions = mockTransactions.filter(t => {
    if (filter === 'all') return true;
    return t.type === filter;
  });
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className={`w-full min-h-screen pb-20 ${isDark ? 'bg-[#1A0E08]' : 'bg-page-warm'}`} data-id="element-3685" data-mp="2sdvw6lhnqcr6">
      <div className={`px-6 pt-6 pb-4 flex items-center gap-4 sticky top-0 z-10 ${isDark ? 'bg-[#1A0E08]' : 'bg-page-warm'}`} data-id="element-3686" data-mp="2nk9q5c60174c">
        <button onClick={onBack} className={`p-2 -ml-2 ${isDark ? 'text-white' : 'text-[#303030]'}`} data-id="element-3687" data-mp="29k8rm3d7ibs1">
          <ArrowLeftIcon className="w-6 h-6" strokeWidth={2} data-id="element-3688" data-mp="2dnet6xpdjes6" />
        </button>
        <h1 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-[#303030]'}`} data-id="element-3689" data-mp="1znnndk90h4p9">Transactions</h1>
      </div>
      <div className="px-6 mt-4" data-id="element-3690" data-mp="24mqgq7fmpmhe">
        <div className="flex gap-3 mb-6" data-id="element-3691" data-mp="24ns3h960bxey">
          {(['all', 'incoming', 'outgoing'] as FilterType[]).map(f => <button key={f} onClick={() => setFilter(f)} className={`px-5 py-2.5 rounded-full text-[14px] font-bold capitalize transition-all ${filter === f ? 'bg-[#F37024] text-white shadow-md' : isDark ? 'bg-[#2D1810] text-[#B8A89E] border border-[rgba(243,112,36,0.1)]' : 'bg-white text-[#818285] border border-[#F0E8E3]'}`} data-id="element-3692" data-mp="3tz2di25xp65j">
              {f}
            </button>)}
        </div>
        <div className="space-y-3" data-id="element-3693" data-mp="1x3qxq2w2xwyk">
          {filteredTransactions.map(t => {
          const Icon = t.icon;
          return <div key={t.id} className={`rounded-2xl p-4 flex items-center gap-4 shadow-sm ${isDark ? 'bg-[#2D1810] border border-[rgba(243,112,36,0.1)]' : 'bg-white'}`} data-id="element-3694" data-mp="1s9v0j2nn4e4g">
                <div className="w-12 h-12 rounded-full flex items-center justify-center shrink-0" style={{
              backgroundColor: `${t.iconBg}15`
            }} data-id="element-3695" data-mp="213hymzfbltgt">
                  <Icon className="w-6 h-6" style={{
                color: t.iconBg
              }} strokeWidth={2} data-id="element-3696" data-mp="2b38r6vkblye9" />
                </div>
                <div className="flex-1" data-id="element-3697" data-mp="lpddd80jbzna">
                  <h4 className={`text-[16px] font-bold mb-0.5 ${isDark ? 'text-white' : 'text-[#303030]'}`} data-id="element-3698" data-mp="goplkk4hfes0">{t.title}</h4>
                  <p className={`text-[12px] ${isDark ? 'text-[#B8A89E]' : 'text-[#818285]'}`} data-id="element-3699" data-mp="33vu3scg1i07d">{t.date}</p>
                </div>
                <div className="text-right" data-id="element-3700" data-mp="38tvpl54uodmj">
                  <p className={`text-[15px] font-bold ${t.type === 'incoming' ? 'text-[#10B981]' : isDark ? 'text-white' : 'text-[#303030]'}`} data-id="element-3701" data-mp="3du9yepe9zrlm">
                    {t.type === 'incoming' ? '+' : '-'} Rs {t.amount}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </motion.div>;
}